import React from 'react'
import Currency from '../../../../../currency'
import { InvoiceItemBlock, InvoiceItemBlockCell, InvoiceItemBlockLabel, InvoiceItemBlockRow, InvoiceItemsBlocks, InvoiceItemBlockValue, InvoiceItemDetails, InvoiceItemsTableCell, InvoiceItemsTableRow, InvoiceItemsTableWrap } from './index.styled'

const InvoiceItemName = React.memo(({ row }) => (
	<>
		{row.name}
		{row.details?.map((detail, i) =>
			<InvoiceItemDetails key={i} className={'level-' + detail.level}>
				{detail.text}
			</InvoiceItemDetails>)}
	</>
))

InvoiceItemName.displayName = 'InvoiceItemName'

const InvoiceItemsTable = React.memo(({ rows, labels, layout }) => {
	const isCompact = layout === 'tablet' || layout === 'mobile'

	if (isCompact) {
		return (
			<InvoiceItemsBlocks>
				{rows.map(row =>
					<InvoiceItemBlock key={row.key} data-testid={'invoice-row-' + row.key}>
						<InvoiceItemBlockRow>
							<InvoiceItemBlockCell>
								<InvoiceItemBlockLabel>{labels.quantity}</InvoiceItemBlockLabel>
								<InvoiceItemBlockValue>{row.quantity}</InvoiceItemBlockValue>
							</InvoiceItemBlockCell>
							<InvoiceItemBlockCell>
								<InvoiceItemBlockLabel>{labels.name}</InvoiceItemBlockLabel>
								<InvoiceItemBlockValue><InvoiceItemName row={row} /></InvoiceItemBlockValue>
							</InvoiceItemBlockCell>
						</InvoiceItemBlockRow>
						<InvoiceItemBlockRow>
							<InvoiceItemBlockCell>
								<InvoiceItemBlockLabel>{labels.unitPrice}</InvoiceItemBlockLabel>
								<InvoiceItemBlockValue><Currency>{row.unitPrice}</Currency></InvoiceItemBlockValue>
							</InvoiceItemBlockCell>
							<InvoiceItemBlockCell>
								<InvoiceItemBlockLabel>{labels.total}</InvoiceItemBlockLabel>
								<InvoiceItemBlockValue><Currency>{row.total}</Currency></InvoiceItemBlockValue>
							</InvoiceItemBlockCell>
						</InvoiceItemBlockRow>
					</InvoiceItemBlock>)}
			</InvoiceItemsBlocks>
		)
	}

	return (
		<InvoiceItemsTableWrap>
			<InvoiceItemsTableRow>
				<InvoiceItemsTableCell className="quantity head">{labels.quantity}</InvoiceItemsTableCell>
				<InvoiceItemsTableCell className="name head">{labels.name}</InvoiceItemsTableCell>
				<InvoiceItemsTableCell className="price head">{labels.unitPrice}</InvoiceItemsTableCell>
				<InvoiceItemsTableCell className="price head">{labels.total}</InvoiceItemsTableCell>
			</InvoiceItemsTableRow>
			{rows.map(row =>
				<InvoiceItemsTableRow key={row.key} data-testid={'invoice-row-' + row.key}>
					<InvoiceItemsTableCell className="quantity">{row.quantity}</InvoiceItemsTableCell>
					<InvoiceItemsTableCell className="name"><InvoiceItemName row={row} /></InvoiceItemsTableCell>
					<InvoiceItemsTableCell className="price"><Currency>{row.unitPrice}</Currency></InvoiceItemsTableCell>
					<InvoiceItemsTableCell className="price"><Currency>{row.total}</Currency></InvoiceItemsTableCell>
				</InvoiceItemsTableRow>)}
		</InvoiceItemsTableWrap>
	)
})

InvoiceItemsTable.displayName = 'InvoiceItemsTable'
export default InvoiceItemsTable
